/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pre_Render_Frame_Cache_Working_TextInputs */



/**
* | output |
* | --- |
* | "Generating film strip frames for all events..." |
*
* @param {Pre_Render_Frame_Cache_Working_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const pre_render_frame_cache_working_text = /** @type {((inputs?: Pre_Render_Frame_Cache_Working_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pre_Render_Frame_Cache_Working_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Génération des images du film strip pour tous les événements...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Erstellung von Filmstreifenbildern für alle Ereignisse...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Generazione di fotogrammi a striscia per tutti gli eventi...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Создание кадров для кинопленки для всех мероприятий...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Generando fotogramas del film strip para todos los eventos...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("为所有活动生成胶片帧……")
	if (locale === "ja") return /** @type {LocalizedString} */ ("すべてのイベントのフィルムストリップフレームを生成します...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सभी आयोजनों के लिए फिल्म स्ट्रिप फ्रेम तैयार करना...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Geração de fotogramas para todos os eventos...")
	return /** @type {LocalizedString} */ ("Generating film strip frames for all events...")
});